import React, { useState } from "react";
import styled from "@emotion/styled";
import { HeadLine } from "../HeadLine";
import { CLink } from "../Anchor";
import { PrimaryButton } from "../Button";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "./thunk";

const Container = styled.div`
  background: #ffffff;
  box-shadow: 0 0 50px rgba(31, 32, 33, 0.08);
  border-radius: 50px 0 0 0;
  z-index: 2;
`;

const Wrapper = styled.div`
  width: min(468px, 90vw);
  height: auto;
  display: flex;
  padding: 2rem 1rem;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
`;

const Actions = styled.div`
  margin-top: 50px;
`;

const Body = styled.div`
  width: min(356px, 100%);
`;

const Input = styled.div`
  & + & {
    margin-top: 25px;
  }
`;

const PasswordLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const ForgotPassword = styled.span`
  display: flex;
  justify-content: flex-end;
`;

const ForgotPasswordLink = styled(CLink)`
  text-transform: uppercase;
`;

const DontHaveAccount = styled.div`
  text-align: center;
  margin: 2rem 0;
  font-size: 14px;
  color: #777984;
`;

const SignUpLink = styled.span`
  color: #c7a878;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    color: #ad9269;
  }
`;

const ErrorMessage = styled.div`
  font-size: 10px;
  padding-top: 1rem;
  color: red;
`;

const CustomerSignin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const message = useSelector((state) => state.localSecurity);
  const [emailAddress, setEmailAddress] = useState("");
  const [emailAddressError, setEmailAddressError] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);

  const onEmailChange = (email) => {
    setEmailAddress(email);

    const EMAIL_REGEX =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (EMAIL_REGEX.test(email) || email.includes(">")) {
      setEmailAddressError(false);
    } else {
      setEmailAddressError(true);
    }
  };

  const onPassChange = (pass) => {
    setPassword(pass);

    if (pass) {
      setPasswordError(false);
    } else {
      setPasswordError(true);
    }
  };

  const submitButtonDisabled =
    emailAddressError ||
    passwordError ||
    emailAddress.length < 5 ||
    password.length < 2;

  return (
    <Container>
      <Wrapper>
        <HeadLine headingText={"Sign In"} />
        <Body>
          <form
            id="sign-in"
            onSubmit={(e) => {
              e.preventDefault();
              if (!submitButtonDisabled) {
                dispatch(loginUser(emailAddress, password));
              }
            }}
          >
            <Input>
              <label htmlFor="email">email</label>
              <input
                type="text"
                name="email"
                autoComplete="email"
                placeholder="Your email address"
                onChange={(e) => onEmailChange(e.target.value.trim())}
                required
              />
              {emailAddressError && (
                <ErrorMessage>Invalid Email Address</ErrorMessage>
              )}
            </Input>
            <Input>
              <PasswordLabelRow>
                <label htmlFor="password">Password</label>
                <ForgotPassword>
                  <ForgotPasswordLink to={"/pass-assist/"}>
                    Forgot Password?
                  </ForgotPasswordLink>
                </ForgotPassword>
              </PasswordLabelRow>
              <input
                type="password"
                name="password"
                autoComplete="current-password"
                placeholder="Password"
                onChange={(e) => onPassChange(e.target.value.trim())}
                required
              />
              {passwordError && <ErrorMessage>Invalid Password</ErrorMessage>}
            </Input>
            <Actions>
              <PrimaryButton disabled={submitButtonDisabled} type="submit">
                Sign In
              </PrimaryButton>
              {message.length && <ErrorMessage>{message}</ErrorMessage>}
              <DontHaveAccount>
                Don't have an account yet?{" "}
                <SignUpLink onClick={() => history.push("/sign-up")}>
                  Sign up
                </SignUpLink>
              </DontHaveAccount>
            </Actions>
          </form>
        </Body>
      </Wrapper>
    </Container>
  );
};

CustomerSignin.propTypes = {};

export { CustomerSignin };
